import { useState, useEffect } from "react";
import { GetStocksForSale } from 'services/stock/stock.service';
import { GetStockByBarcode } from 'services/inventory/product.service';
import { useSelector, useDispatch } from "react-redux";

const useItemDropdown = () => {
    
    const dispatch = useDispatch();
    const [ barcode, setBarcode ] = useState(null)
    const { stockList, stockListLoading } = useSelector((state) => state.stockListForSale);
    const { stockByBarcode, stockByBarcodeLoading } = useSelector((state) => state.stockByBarcode);

    const [productDropdown, setProductDropdown] = useState([]);

    useEffect(() => {
        dispatch(GetStocksForSale());
    }, []);

    useEffect(() => {
        dispatch(GetStockByBarcode(barcode));
    }, [barcode]);

    return {
        productDropdown, 
        setProductDropdown, 
        stockList,
        stockListLoading,
        barcode,
        setBarcode,
        stockByBarcode,
        stockByBarcodeLoading
    };
};

export default useItemDropdown;
